import React from 'react'
import { MDBRow, MDBCol, MDBView, MDBMask } from 'mdbreact'
import { HashLink as Link } from 'react-router-hash-link'
import Moment from 'react-moment'
import ProgressiveImage from 'react-progressive-image'

const CategoryBlogs = ({selectedCategory}) => {

    const blogs = selectedCategory.map((blog)=>
        <>
        <MDBCol className="my-4 my-lg-0 my-md-0" md="4" lg="4">
            <Link smooth className="black-text" to={`/blog/${blog.id}#blog`}>
                <MDBView zoom hover>
                    <ProgressiveImage src={blog.preview.url} placeholder={blog.preview.formats.thumbnail.url}>
                        {(src, loading) => (<img src={src} style={{ filter: loading && "blur(10px)" }} alt="" className="w-100"/>)}
                    </ProgressiveImage>
                    <MDBMask className="flex-center cursor-pointer-style white-text" overlay="black-strong">
                        <h5 className="h5-responsive">Read Blog</h5>
                    </MDBMask>
                </MDBView>
                <h4 className="h4-responsive font-weight-bold my-4">
                    {blog.title}
                </h4>
                <h5 class="h5-responsive mb-4">
                    {blog.description}
                </h5>
                <div className="d-flex justify-content-between mb-lg-5 mb-md-5">
                    <h6 className="h6-responsive">
                        <Moment fromNow>
                            {blog.createdAt}
                        </Moment>
                    </h6>
                    <i className="h6-responsive font-weight-bold grey-text">
                        - Wilca Oconer
                    </i>
                </div>
            </Link>
        </MDBCol>
        </>
    )

    return (
        <MDBRow>
        {blogs}
        </MDBRow>
    )
}

export default CategoryBlogs
